import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Step2 = () => {
	const navigate = useNavigate();
	const [email, setEmail] = useState('');

	const handleContinue = () => {
		if (email === '--remove all data') {
			navigate('/step4');
			return;
		}

		navigate('/step3');
	};

	return (
		<main
			style={{
				minHeight: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '24px',
				background:
					'radial-gradient(circle at top left, rgba(5, 217, 232, 0.16), transparent 30%), radial-gradient(circle at bottom right, rgba(255, 107, 107, 0.14), transparent 24%), linear-gradient(180deg, #07060d 0%, #12101d 100%)',
			}}
		>
			<form
				style={{
					width: 'min(100%, 540px)',
					padding: '32px',
					borderRadius: '24px',
					border: '1px solid rgba(255, 255, 255, 0.12)',
					background: 'rgba(13, 12, 24, 0.92)',
					boxShadow: '0 24px 80px rgba(0, 0, 0, 0.45)',
					display: 'flex',
					flexDirection: 'column',
					gap: '20px',
				}}
			>
				<div>
					<p style={{ margin: 0, color: '#6ef6ff', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', fontSize: '0.85rem' }}>
						Step 2
					</p>
					<h1 style={{ margin: '10px 0 8px', fontSize: 'clamp(2rem, 4vw, 3rem)', lineHeight: 1, color: '#ffffff' }}>
						Tell us about you
					</h1>
					<p style={{ margin: 0, color: 'rgba(233, 238, 255, 0.78)', lineHeight: 1.6 }}>
					</p>
				</div>

				<label style={{ display: 'flex', flexDirection: 'column', gap: '8px', color: '#ffffff', fontWeight: 600 }}>
					Gender
					<select className="App-input" defaultValue="">
						<option value="" disabled>
							Select gender
						</option>
						<option value="men">Male</option>
						<option value="women">Female</option>
					</select>
				</label>

				<label style={{ display: 'flex', flexDirection: 'column', gap: '8px', color: '#ffffff', fontWeight: 600 }}>
					Email
					<input
						type="email"
						placeholder="Enter your email"
						className="App-input"
						value={email}
						onChange={(event) => setEmail(event.target.value)}
					/>
				</label>

				<label style={{ display: 'flex', flexDirection: 'column', gap: '8px', color: '#ffffff', fontWeight: 600 }}>
					Favourite color
					<input
						type="color"
						defaultValue="#05d9e8"
						style={{
							width: '100%',
							height: '56px',
							padding: '8px',
							borderRadius: '10px',
							border: '2px solid #39ff14',
							background: 'rgba(255, 255, 255, 0.1)',
							boxSizing: 'border-box',
							cursor: 'pointer',
						}}
					/>
				</label>

				<label style={{ display: 'flex', flexDirection: 'column', gap: '8px', color: '#ffffff', fontWeight: 600 }}>
					Least favorite colour
					<input
						type="color"
						defaultValue="#ff6b6b"
						style={{
							width: '100%',
							height: '56px',
							padding: '8px',
							borderRadius: '10px',
							border: '2px solid #39ff14',
							background: 'rgba(255, 255, 255, 0.1)',
							boxSizing: 'border-box',
							cursor: 'pointer',
						}}
					/>
				</label>

				<button
					type="button"
					onClick={handleContinue}
					style={{
						marginTop: '4px',
						minHeight: '56px',
						borderRadius: '14px',
						border: 'none',
						background: 'linear-gradient(135deg, #05d9e8 0%, #39ff14 100%)',
						color: '#071018',
						fontSize: '1rem',
						fontWeight: 800,
						letterSpacing: '0.04em',
						cursor: 'pointer',
						textTransform: 'uppercase',
						boxShadow: '0 18px 40px rgba(5, 217, 232, 0.24)',
					}}
				>
					Continue
				</button>
			</form>
		</main>
	);
};

export default Step2;

